import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../utils/auth';
import LoginForm from '../components/LoginForm';

export default function LoginPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  return (
    <>
      <Helmet>
        <title>Login - MAIA Agent 128</title>
      </Helmet>
      <div className="min-h-screen grid-pattern flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-lg shadow-hover p-8 fade-in">
          <div className="text-center mb-8">
            <div className="flex justify-center mb-4">
              <img src="/maia-logo.svg" alt="MAIA" className="h-12" />
            </div>
            <p className="text-gray-600 text-sm">Universal Agent</p>
          </div>

          <LoginForm />
        </div>
      </div>
    </div>
    </>
  );
}
